export const Types= {
    DATOS_CLIENTE_LOADING: 'DATOS_CLIENTE_LOADING',
    DATOS_CLIENTE_ERROR: 'DATOS_CLIENTE_ERROR',

    GET_DATOS_CLIENTE: 'GET_DATA_REQUEST',
    DATOS_CLIENTE_SUCCEEDED: 'DATOS_CLIENTE_SUCCEEDED',

    GET_CONTACTO_EMAIL_REQUEST: 'GET_CONTACTO_EMAIL_REQUEST',   
    CONTACTO_EMAIL_SUCCEEDED: 'CONTACTO_EMAIL_SUCCEEDED',    

    GET_TIENDA_REQUEST: 'GET_TIENDA_REQUEST',   
    GET_TIENDA_REQUEST_SUCCEEDED: 'GET_TIENDA_REQUEST_SUCCEEDED',

    CREATE_CONTACTO_REQUEST: 'CREATE_CONTACTO_REQUEST',
    UPDATE_CONTACTO_REQUEST: 'UPDATE_CONTACTO_REQUEST',
    DELETE_CONTACTO_REQUEST: 'DELETE_CONTACTO_REQUEST',
    CONTACTO_REQUEST_SUCCEEDED: 'CONTACTO_REQUEST_SUCCEEDED',
};

export const startLoading = () => ({type: Types.DATOS_CLIENTE_LOADING});
export const responseError = (error) => ({type: Types.DATOS_CLIENTE_ERROR, error});

export const getClienteData = (clienteId) => ({type: Types.GET_DATOS_CLIENTE, clienteId});
export const responseClienteDataSucceeded = (tipoEmailContactoResponse)  => ({type: Types.DATOS_CLIENTE_SUCCEEDED, tipoEmailContactoResponse });

export const getContactoPorTipoEmail = (clienteId, tipoEmailId) => ({type: Types.GET_CONTACTO_EMAIL_REQUEST, clienteId, tipoEmailId});
export const responseContactoEmailSucceeded = (contactoPorTipoEmailResponse)  => ({type: Types.CONTACTO_EMAIL_SUCCEEDED, contactoPorTipoEmailResponse });

export const getTiendaByCliente = (clienteId) => ({type: Types.GET_TIENDA_REQUEST, clienteId});
export const responseTiendasSucceeded = (tiendas)  => ({type: Types.GET_TIENDA_REQUEST_SUCCEEDED, tiendas });

export const createContacto = (contactoRequest) => ({type: Types.CREATE_CONTACTO_REQUEST, contactoRequest});
export const updateContacto = (contactoRequest) => ({type: Types.UPDATE_CONTACTO_REQUEST, contactoRequest});
export const deleteContacto = (contactoRequest) => ({type: Types.DELETE_CONTACTO_REQUEST, contactoRequest});

export const responseContactoSucceeded = (contactoResponse)  => ({type: Types.CONTACTO_REQUEST_SUCCEEDED, contactoResponse});

